import CrudStoreBuilder from "../common/CrudStoreBuilder";
import equipmentService from "@/services/salles/EquipmentService";

const getters = {
  getEquipmentsByCenterId: (state) => (centerId) => {
    return state.equipments.filter(
      (equipment) => equipment.centerId === centerId
    );
  },
  getAvailableEquipmentsByCenter: (state) => (center) => {
    return state.equipments.filter(
      (equipment) => equipment.centerId === center.id && equipment.available
    );
  },
  getUnavailableEquipmentsByCenter: (state) => (center) => {
    return state.equipments.filter(
      (equipment) => equipment.centerId === center.id && !equipment.available
    );
  },
};

const actions = {
  async loadEquipment({ rootGetters }, equipment) {
    const center = rootGetters["centerModule/getCenterById"](
      equipment.centerId
    );
    const category = rootGetters["categorieModule/getCategoryById"](
      equipment.categoryId
    );
    return {
      center: center,
      categoryName: category.name,
      ...equipment,
    };
  },
};

export default new CrudStoreBuilder()
  .setName("equipment")
  .setService(equipmentService)
  .setDependents(["center", "categorie"])
  .setConverter((x) => {
    x.centerId = x.centerId;
  })
  .includeGetters(getters)
  .includeActions(actions)
  .build();
